import React from 'react';
import { reduce } from 'lodash';
import PropTypes from 'prop-types';

import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { ValidationService } from '@sm360/widget-commons-forms';
import { ADOBE_TAGS, AdobeService, REDIRECTIONS } from '@sm360/widget-commons-general';

import Financing from 'financing/components/Financing/Financing.jsx';

class FinancingForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isFinancingFormValid: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.onClickEvent = this.onClickEvent.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
    }

    onClickEvent() {
        if (this.state.isFinancingFormValid) {
            const windowProxy = WindowProxy.get();
            if (windowProxy) {
                if (this.props.hasAdobeTagging) {
                    AdobeService.eventTrigger(ADOBE_TAGS.FINANCE_FORM(), 'form-submit');
                }
                const locale = LocaleService.getSimpleLocale();
                windowProxy.location.href = REDIRECTIONS[locale].thankyou;
            }
        }
    }

    onFormChange(form) {
        const applicants = form.hasCoApplicant ? [form.primaryApplicant, form.coApplicant] : [form.primaryApplicant];

        this.setState({
            isFinancingFormValid: reduce(
                applicants,
                (result, applicant) => {
                    return ValidationService.validateForm(applicant.validations);
                },
                false
            ),
        });
    }

    handleSubmit(event) {
        event.preventDefault();
    }

    render() {
        const buttonClass = ['sr-button-1 is-small'];
        if (!this.state.isFinancingFormValid) {
            buttonClass.push('is-disabled');
        }

        return (
            <form onSubmit={this.handleSubmit}>
                <Financing
                    onFormChange={this.onFormChange}
                    websiteId={this.props.websiteId}
                    country={this.props.country}
                    hasAdobeTagging={this.props.hasAdobeTagging}
                >
                    <div className="financing__content-btn-section">
                        <button className={buttonClass.join(' ')} type="submit" onClick={this.onClickEvent}>
                            {LocaleService.t('FINANCING.SUBMIT')}
                        </button>
                    </div>
                </Financing>
            </form>
        );
    }
}

FinancingForm.defaultProps = {
    websiteId: null,
    country: null,
    hasAdobeTagging: false,
};

FinancingForm.propTypes = {
    websiteId: PropTypes.number,
    country: PropTypes.string,
    hasAdobeTagging: PropTypes.bool,
};

FinancingForm.displayName = 'FinancingForm';

export default FinancingForm;
